/**
 * @file slideTarget.ts
 * @brief Which product Home's slide button starts: the user's main use, else what they used more.
 *
 * @details
 * The phone's rule (DES 12-10-2026, FRONTEND src/screens/Home/slideTarget.ts);
 * keep the two in step. Meetings → Boardroom, Interpretation → Interpret,
 * Personal notes → Note; Medical, "A bit of everything" or a main use they
 * cannot use → whichever of meetings and sessions they used more in 30 days
 * (GET /api/auth/home-usage), none → Boardroom, else Interpret.
 *
 * On the web "interpretation" means the live web interpreter (a pilot), so a
 * user outside the pilot falls back like any other unavailable main use.
 *
 * @author DES
 * @date 12-10-2026
 */

export type SlideTarget = "boardroom" | "interpret" | "note";

export type SlideEntitlements = { boardroom?: boolean; interpretation?: boolean; notes?: boolean };

export type SlideUsage = { meetings: number; sessions: number } | null | undefined;

export function slideTargetFor(
  primaryUse: string | null | undefined,
  ent: SlideEntitlements,
  usage: SlideUsage,
): SlideTarget | null {
  if (primaryUse === "meetings" && ent.boardroom) return "boardroom";
  if (primaryUse === "interpretation" && ent.interpretation) return "interpret";
  if (primaryUse === "notes" && ent.notes) return "note";

  if (usage && ent.boardroom && ent.interpretation) {
    if (usage.sessions > usage.meetings) return "interpret";
    if (usage.meetings > usage.sessions) return "boardroom";
  }
  if (ent.boardroom) return "boardroom";
  if (ent.interpretation) return "interpret";
  if (ent.notes) return "note";
  return null;
}
